import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import FemalesByRole from './charts/FemaleByRole';
import FemalesVsMalesByRole from './charts/FemalesVsMalesByRole';
import GenderComparison from './charts/GenderComparison';
import GenderSalaryByExperience from './charts/GenderSalaryByExperience';
import GenderSalaryByRole from './charts/GenderSalaryByRole';
import { StyledSection, StyledSubsectionTitle } from './Gender.styled';
import GenderCalculator from './GenderCalculator';

const Gender: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  return (
    <StyledSection>
      <SectionHero
        image={getPublicPath('/images/stateSector/2024/gender.png')}
        title={t('mantechcar24.gender.hero.title')}
        desc={t('mantechcar24.gender.hero.desc')}
      />
      <SectionChart
        title={t('mantechcar24.gender.females-by-role.title')}
        desc={t('mantechcar24.gender.females-by-role.desc')}
        descExtra={t('mantechcar24.gender.females-by-role.descExtra')}
        shareId="femalesbyrole"
        emailSubject={t(
          'mantechcar24.share-modal.females-by-role.email-subject'
        )}
        emailMessage={t('mantechcar24.share-modal.females-by-role.email-text')}
        shareMessage={t('mantechcar24.share-modal.females-by-role.text')}
      >
        <FemalesByRole />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.gender.gender-by-role.title')}
        desc={t('mantechcar24.gender.gender-by-role.desc')}
        descExtra={t('mantechcar24.gender.gender-by-role.descExtra')}
        shareId="genderbyrole"
        emailSubject={t(
          'mantechcar24.share-modal.gender-by-role.email-subject'
        )}
        emailMessage={t('mantechcar24.share-modal.gender-by-role.email-text')}
        shareMessage={t('mantechcar24.share-modal.gender-by-role.text')}
      >
        <FemalesVsMalesByRole />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.gender.gender-comparison.title')}
        desc={t('mantechcar24.gender.gender-comparison.desc')}
        descExtra={t('mantechcar24.gender.gender-comparison.descExtra')}
        shareId="gendercomparison"
        emailSubject={t(
          'mantechcar24.share-modal.gender-comparison.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.gender-comparison.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.gender-comparison.text')}
      >
        <GenderComparison />
      </SectionChart>

      <SectionChart
        title={t('mantechcar24.gender.salary-by-gender.title')}
        desc={t('mantechcar24.gender.salary-by-gender.desc')}
        descExtra={t('mantechcar24.gender.salary-by-gender.descExtra')}
        shareId="salarybygender"
        emailSubject={t(
          'mantechcar24.share-modal.salary-by-gender.email-subject'
        )}
        emailMessage={t('mantechcar24.share-modal.salary-by-gender.email-text')}
        shareMessage={t('mantechcar24.share-modal.salary-by-gender.text')}
      >
        <GenderSalaryByRole />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.gender.calculator-experience.title')}
        desc={t('mantechcar24.gender.calculator-experience.desc')}
        descExtra={t('mantechcar24.gender.calculator-experience.descExtra')}
        shareId="gendersalarybyexperience"
        emailSubject={t(
          'mantechcar24.share-modal.calculator-experience.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.calculator-experience.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.calculator-experience.text')}
      >
        <StyledSubsectionTitle>
          {t('mantechcar24.gender.calculator-experience.calculator.title')}
        </StyledSubsectionTitle>
        <GenderCalculator />
        <StyledSubsectionTitle>
          {t(
            'mantechcar24.gender.calculator-experience.salary-gender-experience.title'
          )}
        </StyledSubsectionTitle>
        <GenderSalaryByExperience />
      </SectionChart>
    </StyledSection>
  );
};

export default Gender;
